import { Component } from '@angular/core';

@Component({
  selector: 'fl-ellipsis-text',
  template: `
    <div flLayout>
      <div flLayoutFlex="1 1 100%" class="Inner">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./ellipsis-text.component.scss'],
})
export class EllipsisTextComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/ellipsis-text/ellipsis-text.component.ts